export const locale = {
  lang: 'it',
  data: {
    MASSIVE_COMPANY_DIALOG: {
      MASSIVE_COMPANY_IMPORT: 'Import massivo aziende',
      CREATION: 'Creazione',
      VERIFICATION: 'Verifica',
      INSERTION: 'Inserimento',
      VALIDATION: 'Validazione',
      IMPORT_OUTCOME: 'Esito importazione',

      COMPANY_TYPE: 'Tipo azienda',
      COMPANY_IMPORT_TYPE_SELLER_DEBTOR: 'Presentazione opportunità invoice trading',
      COMPANY_IMPORT_TYPE_DEBTOR_SELLER: 'Presentazione opportunità reverse',
      COMPANY_IMPORT_TYPE_SELLER: 'Seller',
      COMPANY_IMPORT_TYPE_DEBTOR: 'Debtor',
      DESCRIPTION_SELLER_DEBTOR_1: 'Inserisci nella <strong>prima riga</strong> le informazioni del seller.',
      DESCRIPTION_SELLER_DEBTOR_2: 'Nelle righe sottostanti potrai inserire una lista di clienti.',
      DESCRIPTION_DEBTOR_SELLER_1: 'Inserisci nella <strong>prima riga</strong> le informazioni del debtor.',
      DESCRIPTION_DEBTOR_SELLER_2: 'Nelle righe sottostanti potrai inserire una lista di fornitori.',
      DESCRIPTION_DEBTOR: 'Inserisci un elenco di soli debtor.',
      DESCRIPTION_SELLER: 'Inserisci un elenco di soli seller.',
      ALTERNATIVE: 'In alternativa, puoi caricare un file excel in formato standard:',
      DOWNLOAD_TEMPALTE: 'Scarica TEMPLATE',
      BROWSE: 'Sfoglia',
      IMPORT_FILE: 'Importa file',
      ATTENTION: '*Attenzione: si sta importando un',

      WAITING_IMPORT: 'Importazione in elaborazione...',
      WAITING_UPDATE: 'Aggiornamento in elaborazione...',

      BUSINESS_NAME: 'Ragione Sociale',
      TAX_CODE: 'Codice Fiscale',
      TRANSFER_TYPE: 'Tipologia cessione',
      INVOICE_VALUE: 'Valore fatture emesse',
      REQUIRED_OPERATING_LIMIT: 'Limite operativo richiesto',

      ProSolutoConfirmNotification: 'PRO-SOLUTO con conferma e notifica',
      ProSolutoNoConfirmNotification: 'PRO-SOLUTO Senza conferma con notifica',
      ProSolutoNoConfirmNoNotification: 'PRO-SOLUTO senza conferma e notifica',
      ProSolvendoConfirmNotification: 'PRO-SOLVENDO con conferma e notifica',
      ProSolvendoNoConfirmNotification: 'PRO-SOLVENDO senza conferma con notifica',
      ProSolvendoNoConfirmNoNotification: 'PRO-SOLVENDO senza conferma e notifica',
      ProSolvendoConfirmNoNotification: 'PRO-SOLVENDO con conferma senza notifica',
      IasProSolutoConfirmNotification: 'IAS-Compliant - PRO-SOLUTO con conferma con notifica',
      IasProSolutoConfirmNoNotification: 'IAS-Compliant - PRO-SOLUTO con conferma senza notifica',
      IasProSolutoNoConfirmNotification: 'IAS-Compliant - PRO-SOLUTO senza conferma con notifica',
      IasProSolutoNoConfirmNoNotification: 'IAS-Compliant - PRO-SOLUTO senza conferma senza notifica',

      CRIBIS: 'CRIBIS',
      COMPANY: 'Azienda',
      ROLE: 'Ruolo',
      LINK: 'Legame',
      INFO_TOOLTIP: {
        CRIBIS: 'Indica se il codice fiscale inserito è stato trovato sulla banca dati CRIBIS (valido solo per aziende Italiane)',
        COMPANY: `Indica se l'azienda risulta già censita`,
        ROLE: `Indica se un'azienda già censita risulta anche presente nel ruolo richiesto (seller o debtor)`,
        LINK: `Indica se esiste già un legame seller-debtor tra le aziende`,
      },
      CUSTOMERS: 'Clienti',
      SUPPLIERS: 'Fornitori',

      FIRST_NAME: 'Nome',
      LAST_NAME: 'Cognome',
      EMAIL: 'Email',
      PHONE: 'Telefono',

      IMPORT_COMPLETE: 'Importazione completata con successo',

      ACTION: {
        CANCEL: 'Annulla',
        SEND: 'Invia',
        CONFIRM: 'Conferma',
        BACK: 'Indietro',
      },

      ERROR: {
        ZERO: 'Attenzione: alcuni valori sono impostati a 0',
        ERROR: 'Errore',
      },

      FILE_WARNING: {
        SELLER: 'elenco di soli seller',
        DEBTOR: 'elenco di soli debtor',
        SELLER_DEBTOR: 'seller e un elenco di suoi clienti',
        DEBTOR_SELLER: 'debtor e un elenco di suoi fornitori',
      },
    },
  },
};
